var map = {
	"./home1.gif": 9934,
	"./home2.png": 9050,
	"./home3.gif": 1200,
	"./home4.gif": 2891,
	"./home5.gif": 3586,
	"./home6.gif": 2381,
	"./home7.gif": 9748,
	"./home8.gif": 8975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8504;